import React, { useState, useEffect } from 'react';
import { Layout, Row, Col } from 'antd';

import { API } from '../../AxiosWrapper';
import FreeCompartments from './FreeCompartments';
import LockersCount from './LockersCount';
import DateRangeStats from './DateRangeStats';
import { useHandleApiError } from '../shared/hooks'

const { Content } = Layout

const Dashboard = ({ branches, branchId }) => {
  const handleApiError = useHandleApiError();

  const [loadingGeneralStats, setLoadingGeneralStats] = useState(false)
  const [generalStats, setGeneralStats] = useState({})

  const getGeneralStats = () => {
    let url = 'Dashboard/general'
    if (branchId) url += `?branchId=${branchId}`;

    setLoadingGeneralStats(true)
    API.GET(url)
      .then(response => setGeneralStats(response.data))
      .catch(handleApiError)
      .finally(() => setLoadingGeneralStats(false))
  }

  useEffect(getGeneralStats, [branchId]) // eslint-disable-line react-hooks/exhaustive-deps

  const branch = branches.find(b => b.id === branchId)

  return (
    <Layout>
      <Content>
        <Row gutter={24}>
          <Col xs={24} lg={12}>
            <DateRangeStats branchId={branchId} />
          </Col>
          <Col xs={24} lg={12}>
            <LockersCount generalStats={generalStats} loading={loadingGeneralStats} />
            <FreeCompartments
              data={generalStats?.freeCompartments}
              loading={loadingGeneralStats}
              branchName={branch?.name}
            />
          </Col>
        </Row>
      </Content>
    </Layout>
  );
}

export default Dashboard;
